export {
    dsplL,
    dsplM,
    dsplS,
    h1,
    h2,
    h3,
    h4,
    h5,
    bodyL,
    bodyLBold,
    bodyM,
    bodyMBold,
    bodyS,
    bodySBold,
    bodyXS,
    bodyXSBold,
    bodyXXS,
    bodyXXSBold,
    textL,
    textLBold,
    textM,
    textMBold,
    textS,
    textSBold,
    textXS,
    textXSBold,
} from '@sberdevices/plasma-typo';
